import { Color } from '@tmh-website/shared/colors';
import addDays from 'date-fns/addDays';
import startOfISOWeek from 'date-fns/startOfISOWeek';
import startOfWeek from 'date-fns/startOfWeek';
import { createContext, useContext } from 'react';
import { DayPickerSingleProps } from 'react-day-picker';
import { CalendarThemeColor } from './Calendar.theme';

export interface CalendarContextValue {
  themeColor: CalendarThemeColor;
  value?: Date;
  onSelect?: DayPickerSingleProps['onSelect'];
}

export const CalendarContext = createContext<CalendarContextValue>({
  themeColor: Color.Neutral_0_White,
  value: new Date(),
  onSelect: () => {},
});

export function getWeekdays(
  locale?: Locale,
  /** The index of the first day of the week (0 - Sunday). */
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6,
  /** Use ISOWeek instead of locale/ */
  ISOWeek?: boolean
): Date[] {
  const start = ISOWeek ? startOfISOWeek(new Date()) : startOfWeek(new Date(), { locale, weekStartsOn });

  const days: Date[] = [];
  for (let i = 0; i < 7; i++) {
    const day = addDays(start, i);
    days.push(day);
  }
  return days;
}

export function useCalendar() {
  const { onSelect, themeColor, value } = useContext(CalendarContext);

  return {
    onSelect,
    themeColor,
    value,
  };
}
